export default "__VITE_ASSET__815032e0__"